import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-share",
  "use": "icon-share-usage",
  "viewBox": "0 0 129.5 141.5",
  "content": "<symbol viewBox=\"0 0 129.5 141.5\" id=\"icon-share\">\r\n<g>\r\n\t<path d=\"M129.5,23.75c0,13.117-10.633,23.75-23.75,23.75S82,36.867,82,23.75\r\n\t\tS92.633,0,105.75,0S129.5,10.633,129.5,23.75\" />\r\n\t<path d=\"M129.5,117.75c0,13.117-10.633,23.75-23.75,23.75S82,130.867,82,117.75\r\n\t\tS92.633,94,105.75,94S129.5,104.633,129.5,117.75\" />\r\n\t<path d=\"M47.5,70.75c0,13.117-10.633,23.75-23.75,23.75S0,83.867,0,70.75\r\n\t\tS10.633,47,23.75,47S47.5,57.633,47.5,70.75\" />\r\n\t<polygon points=\"103.015,122.521 12.689,70.75 103.015,18.979 108.485,28.521\r\n\t\t34.81,70.75 108.485,112.979 \t\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/general/svg/share.svg
// module id = ./app/general/svg/share.svg
// module chunks = app